module.exports = __webpack_public_path__ + "static/img/beian.d0289dc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/beian.png
// module id = 5/dF
// module chunks = 6